export async function notifyTelegram({ text, subject, email, fullName }) {
  try {
    await fetch('/.netlify/functions/notify-telegram', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text, subject, email, fullName }),
    });
  } catch (err) {
    // Never let a notification failure block the actual chat message from sending
    console.error('Telegram notification failed:', err);
  }
}